import { fromPromise } from 'xstate';
import { AccessIssueSolutionLabel } from '@acp/shared';
import {
    getAccessIssuesByPropertyV2,
    resolveAccessIssueByAgencyAction,
} from '../../../service';

export const accessIssuesWizardActors = {
    getAccessIssuesByProperty: fromPromise(({
        input: { propertyId },
    }: {
        input: {
            propertyId: number;
        };
    }) => getAccessIssuesByPropertyV2(propertyId)),
    actionProblem: fromPromise(async ({
        input,
    }: {
        input: {
            propertyId: number;
            solutionLabel: AccessIssueSolutionLabel;
            notes?: string;
            date?: Date;
        };
    }) => {
        await resolveAccessIssueByAgencyAction(
            input.propertyId,
            input.solutionLabel,
            input.notes,
            input.date
        );

        return { solutionLabel: input.solutionLabel };
    }),
};
